// document.addEventListener("DOMContentLoaded", function () {
//   const moveBisButton = () => {
//     const bisButton = document.querySelector("#boost-sd__bis-notify-me-button");
//     const priceElement = document.querySelector(".entry-short-description");

//     if (bisButton && priceElement && priceElement.parentNode) {
//       // Only move if not already after the price element
//       if (priceElement.nextSibling !== bisButton) {
//         priceElement.insertAdjacentElement("afterend", bisButton);
//         console.log(".boost-sd__bis-notify-me-button moved after .entry-price.price");
//         bisButton.classList.add("btn","btn-primary","btn-rounded","text-uppercase","single_add_to_cart_button");
//       }
//     }
//   };

//   // Run after DOM load
//   moveBisButton();

//   // Also handle dynamically injected elements (Boost filter, AJAX, etc.)
//   const observer = new MutationObserver(moveBisButton);
//   observer.observe(document.body, { childList: true, subtree: true });
  
//   //notify me button click event


// const clickRomaniaOption = () => {
//     // Select all country option elements
//     const countryOptions = document.querySelectorAll(".boost-sd__bis-country-option");
//     const phoneInput = document.querySelector(".boost-sd__bis-phone-input");
    
//     for (const option of countryOptions) {
//       const nameEl = option.querySelector(".boost-sd__bis-country-name");
//       if (nameEl && nameEl.textContent.trim() === "Romania") {
//         option.click();
//         console.log("✅ Clicked the Romania country option");
//         return true; // stop after first match
//       }
//     }
//     return false;
//   };

//   // Run immediately after DOM load
//   if (!clickRomaniaOption()) {
//     // In case content loads later (Boost dropdown opens dynamically)
//     const clickObserver = new MutationObserver(() => {
//       const success = clickRomaniaOption();
//       if (success) clickObserver.disconnect(); // stop observing once clicked
//     });
//     clickObserver.observe(document.body, { childList: true, subtree: true });
//   }

// const updatePhoneField = () => {
//     const phoneInput = document.querySelector("#boost-sd__bis-phone-input");
//     const mailInput = document.querySelector("#boost-sd__bis-email-input");
//     const titleElement = document.querySelector("#boost-sd__bis-popup-description");
//     const emailLabel = document.querySelector("label[for='boost-sd__bis-email-input']");
//     if (phoneInput && mailInput && titleElement && emailLabel) {
//       phoneInput.setAttribute("data-country-format", "07xxXXXxxx");
//       phoneInput.setAttribute("placeholder", "07xxXXXxxx");
//       mailInput.setAttribute("placeholder", "E-mailul tău");
//       titleElement.textContent = "Completează datele tale de contact și primești notificare pe e-mail, atunci când produsul se întoarce pe stoc!";
//       emailLabel.textContent = "Adresa de E-mail";
//       console.log("✅ Updated phone input format and placeholder to 07xxXXXxxx");
//       return true;
//     }
//     return false;
//   };

//   // Run immediately after DOM load
//   if (!updatePhoneField()) {
//     // Watch for dynamic rendering (Boost often injects elements asynchronously)
//     const observer_placeholder = new MutationObserver(() => {
//       const success = updatePhoneField();
//       if (success) observer_placeholder.disconnect(); // stop once done
//     });
//     observer_placeholder.observe(document.body, { childList: true, subtree: true });
//   }

// });
  /* ---------------------------------------------
  BOOST AI SEARCH - UPDATE CART COUNT & DRAWER
   --------------------------------------------- */
  // Boost keeps the instant-search dropdown open until the user clicks
  // outside it or presses Escape. An "Adauga" click inside the dropdown
  // is neither, so once the cart drawer opens the suggestions stay on
  // screen above the overlay. Close them explicitly after a cart add.
  function closeBoostInstantSearch() {
    var container = document.querySelector('.boost-sd__instant-search-container');
    var input = document.querySelector(
      'input.boost-sd__search-bar-input, input.boost-sd__instant-search-input, ' +
      'input.boost-sd__search-input, .boost-sd__search-bar input[type="search"], ' +
      '.boost-sd__search-bar input[type="text"]'
    );
    if (!container && !input) return;
    try {
      if (input) {
        input.dispatchEvent(new KeyboardEvent('keydown', { key: 'Escape', code: 'Escape', keyCode: 27, which: 27, bubbles: true }));
        input.blur();
      }
      // Boost's click-outside handler listens on the document.
      var target = document.body;
      ['pointerdown', 'mousedown', 'click'].forEach(function (type) {
        target.dispatchEvent(new MouseEvent(type, { bubbles: true, cancelable: true, view: window }));
      });
    } catch (e) { /* noop */ }
  }
  window.closeBoostInstantSearch = closeBoostInstantSearch;

  // Intercept all fetch requests to detect cart additions
  (function() {
    // Intercept Fetch API
    var originalFetch = window.fetch;
    window.fetch = function() {
      var fetchPromise = originalFetch.apply(this, arguments);
      var url = arguments[0];
      
      // Check if this is a cart add request
      if (typeof url === 'string' && (url.indexOf('/cart/add') !== -1 || url.indexOf('cart/add') !== -1)) {
        fetchPromise.then(function(response) {
          if (response.ok) {
            closeBoostInstantSearch();
            // Clone response to get cart data
            response.clone().json().then(function(data) {
              // Trigger the theme's native cart update which will:
              // 1. Update cart count
              // 2. Update cart contents
              // 3. Open the drawer/popup automatically
              if (typeof Shopify !== 'undefined' && typeof Shopify.KT_getCart === 'function') {
                // Use the theme's cart update function
                Shopify.KT_getCart();
              } else {
                // Fallback: manually update count and mark for refresh
                if (data && data.item_count !== undefined) {
                  $('.cartCount').text(data.item_count);
                } else {
                  fetch('/cart.js')
                    .then(function(res) { return res.json(); })
                    .then(function(cart) {
                      $('.cartCount').text(cart.item_count);
                    });
                }
                $('.mini-cart').addClass('load');
              }
              
              // Add animation to cart icon
              $('.mini-cart .icon-count').addClass('cart-updated');
              setTimeout(function() {
                $('.mini-cart .icon-count').removeClass('cart-updated');
              }, 600);
            }).catch(function() {
              // If response parsing fails, still trigger cart update
              if (typeof Shopify !== 'undefined' && typeof Shopify.KT_getCart === 'function') {
                Shopify.KT_getCart();
              } else {
                $('.mini-cart').addClass('load');
              }
            });
          }
          return response;
        }).catch(function() {
          // Silently handle errors
        });
      }
      
      return fetchPromise;
    };
    
    // Also intercept XMLHttpRequest for older implementations
    var originalXHROpen = XMLHttpRequest.prototype.open;
    var originalXHRSend = XMLHttpRequest.prototype.send;
    
    XMLHttpRequest.prototype.open = function(method, url) {
      this._url = url;
      return originalXHROpen.apply(this, arguments);
    };
    
    XMLHttpRequest.prototype.send = function() {
      var xhr = this;
      if (xhr._url && typeof xhr._url === 'string' && xhr._url.indexOf('/cart/add') !== -1) {
        xhr.addEventListener('load', function() {
          if (xhr.status >= 200 && xhr.status < 300) {
            closeBoostInstantSearch();
            setTimeout(function() {
              if (typeof Shopify !== 'undefined' && typeof Shopify.KT_getCart === 'function') {
                Shopify.KT_getCart();
              }
              $('.mini-cart .icon-count').addClass('cart-updated');
              setTimeout(function() {
                $('.mini-cart .icon-count').removeClass('cart-updated');
              }, 600);
            }, 100);
          }
        });
      }
      return originalXHRSend.apply(this, arguments);
    };
  })();

  // Discount code observer - show message when code is entered
  (function() {
    var checkDiscountCode = function() {
      var discountInput = document.querySelector('#discount_code');
      var cuponMsg = document.querySelector('.cupon_msg_two');
      if (discountInput && cuponMsg) {
        if (discountInput.value !== '') {
          cuponMsg.classList.remove('d-none');
        } else {
          cuponMsg.classList.add('d-none');
        }
      }
    };

    // Check on page load
    document.addEventListener('DOMContentLoaded', checkDiscountCode);

    // Check on input change
    document.addEventListener('input', function(e) {
      if (e.target && e.target.id === 'discount_code') {
        checkDiscountCode();
      }
    });

    // MutationObserver for dynamically added #discount_code
    var observer = new MutationObserver(function(mutations) {
      var discountInput = document.querySelector('#discount_code');
      if (discountInput) {
        checkDiscountCode();
      }
    });
    observer.observe(document.body, { childList: true, subtree: true });
  })();

  /* ---------------------------------------------
     BOOST AI SEARCH - FIX CARET POSITION IN SEARCH INPUT
     Boost renders the search bar as a controlled React input.
     When the user focuses/clicks the input while it already has
     text, Boost re-renders and resets the caret to position 0
     (the cursor appears in front of the text instead of at the
     end / where the user clicked). This normalises the caret:
       - if it lands at 0/0 while there is content, move it to
         the end of the text.
     Any legitimate click-in-the-middle is preserved because the
     browser will have already set a non-zero selection before
     our fix runs.
     --------------------------------------------- */
  (function () {
    var SEARCH_INPUT_SELECTOR =
      'input.boost-sd__search-bar-input, ' +
      'input.boost-sd__instant-search-input, ' +
      'input.boost-sd__search-input, ' +
      '.boost-sd__search-bar input[type="search"], ' +
      '.boost-sd__search-bar input[type="text"], ' +
      '.boost-sd__instant-search-container input[type="search"], ' +
      '.boost-sd__instant-search-container input[type="text"]';

    function moveCaretToEnd(input) {
      if (!input || typeof input.value !== 'string') return;
      var len = input.value.length;
      if (!len) return;
      try { input.setSelectionRange(len, len); } catch (e) { /* noop */ }
    }

    function fixIfBuggy(input) {
      if (!input || !input.value) return;
      if (document.activeElement !== input) return;
      if (input.selectionStart === 0 && input.selectionEnd === 0) {
        moveCaretToEnd(input);
      }
    }

    function schedule(input) {
      // Boost re-renders after focus/click; run twice to beat the render.
      requestAnimationFrame(function () {
        fixIfBuggy(input);
        setTimeout(function () { fixIfBuggy(input); }, 0);
      });
    }

    function isBoostSearchInput(el) {
      return !!(el && el.matches && el.matches(SEARCH_INPUT_SELECTOR));
    }

    document.addEventListener('focusin', function (e) {
      if (isBoostSearchInput(e.target)) schedule(e.target);
    }, true);

    document.addEventListener('mouseup', function (e) {
      if (isBoostSearchInput(e.target)) schedule(e.target);
    }, true);
  })();

  /* ---------------------------------------------
     2PERFORMANT - HIDE PHONE / CALL-CENTER ELEMENTS FOR AFFILIATE TRAFFIC
     Visitors who arrive through a 2Performant affiliate link can still
     place an order by phone; 2Performant can't attribute call-center
     orders back to the affiliate, so the site loses tracked commission
     on them. We detect that traffic from the same 2pau/2ptt/2ptu/2prp/
     2pdlst quicklink params theme.liquid already checks for noindex, and
     remember it in a cookie so it stays hidden as they browse other pages.
     --------------------------------------------- */
  (function () {
    var AFFILIATE_PARAMS = ['2pau', '2ptt', '2ptu', '2prp', '2pdlst'];
    var COOKIE_NAME = 'intimax_affiliate_visit';
    var COOKIE_DAYS = 30;

    function setCookie(name, value, days) {
      var expires = new Date(Date.now() + days * 24 * 60 * 60 * 1000).toUTCString();
      document.cookie = name + '=' + value + '; expires=' + expires + '; path=/; SameSite=Lax';
    }

    function hasCookie(name) {
      return document.cookie.indexOf(name + '=1') !== -1;
    }

    function urlHasAffiliateParams() {
      var params = new URLSearchParams(window.location.search);
      return AFFILIATE_PARAMS.some(function (key) { return params.has(key); });
    }

    var isAffiliateTraffic = urlHasAffiliateParams() || hasCookie(COOKIE_NAME);
    if (isAffiliateTraffic) setCookie(COOKIE_NAME, '1', COOKIE_DAYS);

    // Every phone link on the site, the whole phone column in the
    // footer's widget-about-info block (label included, not just the
    // link), and the floating action buttons (WhatsApp, call, etc. -
    // added by a third-party app, so they can render after page load).
    var LEAK_SELECTOR = '.widget-about-info > .row > .col-sm-6.col-md-4, #omega-cta-button-23103';

    function applyLeakVisibility() {
      if (typeof jQuery === 'undefined') return;
      if (isAffiliateTraffic) {
        jQuery(LEAK_SELECTOR).hide();
      } else {
        jQuery(LEAK_SELECTOR).show();
      }
    }

    applyLeakVisibility();

    // The WhatsApp button is injected by an app after our script runs,
    // so re-apply visibility whenever new nodes show up.
    var leakObserver = new MutationObserver(applyLeakVisibility);
    leakObserver.observe(document.body, { childList: true, subtree: true });
  })();
